import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Tag,
  Select,
  Form,
  Input,
  DatePicker,
  InputNumber,
  Switch,
  Row,
  Col,
} from "antd";
import {
  CloseOutlined,
  FormOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  // DeleteTwoTone,
  // PlusOutlined,
} from "@ant-design/icons";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { ModuleColor } from "../../icons/ApplicationColor";
import { useNavigate, useParams } from "react-router-dom";
import UpdateSub from "./UpdateSub";
import { env } from "../../../config";
// import { useIsAuthenticated } from "@azure/msal-react";
const { Option } = Select;
const { RangePicker } = DatePicker;
const EditSubRow = ({
  record,
  setExpandedRowKeys,
  CreateSuccessfull,
  CreateFailed,
  enrollments,
  billings,
  category,
  subscription,
  handleCancel,
  categoryType,
}) => {
  const formRef = useRef();
  //console.log(record);
  //console.log(enrollments, "ENROLLMENTS");
  // const handleReset = () => {
  //   formRef.current.resetFields();
  // };

  const history = useNavigate();
  const { id } = useParams();
  const [appData, setAppData] = useState();
  const [showModal, setShowModal] = useState(false);
  const [isUserExists, setIsUserExists] = useState(false);
  const [ilt, setIlt] = useState(false);
  const [AiEnabled, setAiEnabled] = useState(false);
  const AppData = useSelector((state) => state?.user?.data?.applications);
  const [allocated_views_switch, setAllocated_views_switch] = useState(
    record?.allocated_view_flag ?? true
  );

  useEffect(() => {
    setIlt(record?.ilt_enabled === true ? true : false);
    setAiEnabled(record?.ai_enabled === true ? true : false);
  }, [record?.ilt_enabled, record?.ai_enabled]);

  useEffect(() => {
    if (AppData) {
      const appDataObject = AppData.reduce((accumulator, app) => {
        accumulator[app.name] = app.id;
        return accumulator;
      }, {});
      setAppData(appDataObject);
    }
  }, [AppData]);
  const renderApplication = () => {
    const applicationName = record.application;
    return appData[applicationName] || null;
  };
  //console.log(record);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");
  const onFinish = async (values) => {
    const { dateRange, products, ai_enabled, ...otherValues } = values;
    //console.log(values);
    const filteredValues = Object.fromEntries(
      Object.entries(otherValues).filter(
        ([_, value]) => value !== undefined && value !== null
      )
    );
    const startDate = dayjs(dateRange[0]);
    const endDate = dayjs(dateRange[1]);
    const payload = {
      ...filteredValues,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: record.organization,
      application: renderApplication(),
      ...(record.application === "Review Cloud" && {
        ai_enabled: values.ai_enabled,
      }),
    };
    // let productsPayload = [];
    // if (products && products.length > 0) {
    //   productsPayload = products.map((product) => {
    //     const { dateRange, ...otherProductValues } = product;
    //     const filteredProductValues = Object.fromEntries(
    //       Object.entries(otherProductValues).filter(
    //         ([_, value]) => value !== undefined && value !== null
    //       )
    //     );

    //     const productStartDate = dayjs(dateRange[0]);
    //     const productEndDate = dayjs(dateRange[1]);

    //     return {
    //       ...filteredProductValues,
    //       start_date: productStartDate.format("YYYY-MM-DD"),
    //       end_date: productEndDate.format("YYYY-MM-DD"),
    //       status: true,
    //     };
    //   });
    //   payload.products = productsPayload;
    // }

    //console.log(payload, "finalPayload");
    try {
      await Axios.put(`/orgsubscription/${record.id}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      // handleCancel();
      CreateSuccessfull("edited");
    } catch (err) {
      //console.log(err);
      CreateFailed("edited");
    }
  };
  const handleUpgrade = (id) => {
    setShowModal(true);
  };

  const handleReset = (id) => {
    handleCancel(id);
    // resetCall();
    // formRef.current.resetFields();
  };
  const [form] = Form.useForm();

  // const compBldrProducts = record?.all_products || [];

  const addRow = () => {
    const values = form.getFieldValue("products") || [];
    form.setFieldsValue({ products: [...values, {}] });
  };

  // const removeRow = (index) => {
  //   const values = form.getFieldValue("products");
  //   const removedRowValues = values[index];
  //   console.log(removedRowValues?.id?.value, "istheremovedProduct");
  //   values.splice(index, 1);
  //   form.setFieldsValue({ products: values });
  // };

  // eslint-disable-next-line no-unused-vars
  const resetCall = () => {
    if (record.application === "CompBldr") {
      const initialProducts = record.subscribed_products || [];
      //console.log(initialProducts, "record.products");
      if (initialProducts.length > 0) {
        form.setFieldsValue({
          products: initialProducts.map((product) => ({
            ...product,
            id: product.product,
            dateRange: [
              dayjs(product.start_date, "YYYY-MM-DD"),
              dayjs(product.end_date, "YYYY-MM-DD"),
            ],
          })),
        });
      } else {
        form.setFieldsValue({
          products: null,
        });
      }
      addRow();
    }
  };
  useEffect(() => {
    //console.log(record.application, "Application");
    if (record.application === "CompBldr") {
      const initialProducts = record.subscribed_products || [];
      //console.log(initialProducts, "record.products");
      if (initialProducts.length > 0) {
        form.setFieldsValue({
          products: initialProducts.map((product) => ({
            ...product,
            id: product.product,
            dateRange: [
              dayjs(product.start_date, "YYYY-MM-DD"),
              dayjs(product.end_date, "YYYY-MM-DD"),
            ],
          })),
        });
      } else {
        const setInitailValue = form.getFieldValue("products") || [];
        if (setInitailValue?.length < 1) {
          addRow();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);
  // const isProductUnique = (value) => {
  //   return new Promise((resolve, reject) => {
  //     console.log(value, form.getFieldValue("products"), "isProductUnique");

  //     const selectedProducts = form
  //       .getFieldValue("products")
  //       .map((product) => product.id);

  //     const isUnique =
  //       selectedProducts.indexOf(value) === selectedProducts.lastIndexOf(value);

  //     console.log("Is unique?", isUnique);

  //     if (isUnique) {
  //       resolve();
  //     } else {
  //       reject("Product must be unique"); // Reject the promise with an error message
  //     }
  //   });
  // };
  const handleFormChange = async (changedValues, allValues) => {
    if ("contract_id" in changedValues && allValues.contract_id.length > 2) {
      if (
        "contract_id" in changedValues &&
        allValues.contract_id === record.contract_id
      ) {
        setIsUserExists(false);
      } else {
        const response = await Axios.get(
          `/contractidcheck/${id}/?search=${allValues.contract_id}`
        );
        //console.log(response);
        setIsUserExists(response.data.exists);
      }
    }
  };

  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Contract ID already exists");
      } else {
        resolve();
      }
    });
  };
  return (
    <div style={{ marginBottom: "0.5rem", padding: "15px" }}>
      <p
        style={{
          margin: 0,
          marginTop: "1rem",
        }}
      >
        <Tag
          color={ModuleColor(record.application)}
          style={{ padding: "0.5rem" }}
        >
          <span className="tag-container">
            {record.application} {"> "}EDIT DETAILS
          </span>
        </Tag>
      </p>
      <div style={{ marginTop: "1rem" }}>
        <Form
          name="complex-form"
          onFinish={onFinish}
          onValuesChange={handleFormChange}
          form={form}
          layout="vertical"
          ref={formRef}
          initialValues={{
            dateRange: [
              record.start_date ? dayjs(record.start_date, "YYYY-MM-DD") : null,
              record.end_date ? dayjs(record.end_date, "YYYY-MM-DD") : null,
            ],
          }}
          labelCol={{
            span: 25,
          }}
          wrapperCol={{
            span: 80,
          }}
          style={{
            Width: "100%",
          }}
          requiredMark={false}
        >
          <div className="group1" style={{ padding: "0rem" }}>
            <div className="antd-test-modal" style={{ marginTop: "2rem" }}>
              <Row gutter={20} style={{ marginLeft: "3rem" }}>
                <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                  <Form.Item
                    label={<p className="my-form-lables">Contract ID</p>}
                  >
                    <Form.Item
                      name="contract_id"
                      initialValue={record?.contract_id}
                      rules={[
                        {
                          required: true,
                          message: "ID is required",
                        },
                        {
                          min: 3,
                          message: "Minimum 3 characters required",
                        },
                        {
                          validator: checkUserExists,
                          validateTrigger: "onChange",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Contract id"
                        name="contract_id"
                        className="my-form-input-antd-test"
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                  <Form.Item
                    label={<p className="my-form-lables">Billing Cycle</p>}
                  >
                    <Form.Item
                      name="billing_cycle"
                      initialValue={record?.billing_cycle}
                    >
                      <Select
                        placeholder="Billing"
                        name="billing_cycle"
                        className="my-form-input-antd-test"
                      >
                        {billings?.billing_cycle?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Form.Item>
                </Col>
                {record.application !== "CompBldr" &&
                  record.application !== "JobBldr" &&
                  record.application !== "JA/MP" &&
                  record.application !== "GRADEBldr" &&
                  record.application !== "Comp Project" && (
                    <>
                      <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Subscription Type</p>
                          }
                        >
                          <Form.Item
                            name="subscription_type"
                            initialValue={record?.subscription_type}
                          >
                            <Select
                              placeholder="Subscription Type"
                              name="subscription_type"
                              className="my-form-input-antd-test"
                            >
                              {record.application !== "TraineryLMS"
                                ? subscription?.subscription_type?.map(
                                    (app) => (
                                      <Option key={app} value={app}>
                                        {app}
                                      </Option>
                                    )
                                  )
                                : categoryType?.contract_type?.map((app) => (
                                    <Option key={app} value={app}>
                                      {app}
                                    </Option>
                                  ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                        <Form.Item
                          label={<p className="my-form-lables">Category</p>}
                        >
                          <Form.Item
                            name="subscription_category"
                            initialValue={record?.subscription_category}
                          >
                            <Select
                              placeholder="Category"
                              name="subscription_category"
                              className="my-form-input-antd-test"
                            >
                              {category?.subscription_category?.map((app) => (
                                <Option key={app} value={app}>
                                  {app}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                  <Form.Item
                    label={<p className="my-form-lables">Start and End Date</p>}
                  >
                    <Form.Item
                      name="dateRange"
                      rules={[
                        {
                          required: true,
                          message: "date is required",
                        },
                      ]}
                    >
                      <RangePicker
                        placeholder={["Start Date", "End Date"]}
                        name="dateRange"
                        className="my-form-input-antd-test"
                        disabled={[true, false]}
                        format="MMM-DD-YYYY"
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>
                {record.application === "Comp Project" && (
                  <>
                    <Col xs={24} sm={12} md={5} lg={6} xl={6}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Enrollment type</p>
                        }
                      >
                        <Form.Item
                          name="enrollment_type"
                          initialValue={record?.enrollment_type}
                        >
                          <Select
                            placeholder="Enrollment Type"
                            name="enrollment_type"
                            disabled
                            className="my-form-input-antd-test"
                          >
                            {enrollments?.enrollment_type?.map((app) => (
                              <Option key={app} value={app}>
                                {app}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </>
                )}
                {record.application === "Review Cloud" && (
                  <>
                    <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                      <Form.Item
                        label={<p className="my-form-lables">AI Enabled</p>}
                      >
                        <Form.Item name="ai_enabled">
                          <Switch
                            checkedChildren="Enabled"
                            unCheckedChildren="Disabled"
                            checked={AiEnabled}
                            onChange={(checked) => {
                              setAiEnabled(checked);
                            }}
                            style={{
                              backgroundColor: AiEnabled
                                ? "#87d068"
                                : "#1890ff",
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </div>

            {record.application === "Trak Learning" ||
            record.application === "Trak Coaching" ? (
              <>
                <div className="antd-test-modal">
                  <Row gutter={20} style={{ marginLeft: "3rem" }}>
                    <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Enrollment type</p>
                        }
                      >
                        <Form.Item
                          name="enrollment_type"
                          initialValue={record?.enrollment_type}
                        >
                          <Select
                            placeholder="Enrollment Type"
                            name="enrollment_type"
                            className="my-form-input-antd-test"
                          >
                            {enrollments?.enrollment_type?.map((app) => (
                              <Option key={app} value={app}>
                                {app}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                      <Form.Item
                        name="no_of_clients"
                        label={<p className="my-form-lables">No. of Clients</p>}
                      >
                        <Input
                          placeholder="Number of clients"
                          name="no_of_clients"
                          className="my-form-input-antd-test"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    {env !== "prod" ? (
                      <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                        <Form.Item
                          label={<p className="my-form-lables">ILT</p>}
                        >
                          <Form.Item name="ilt_enabled">
                            <Switch
                              checkedChildren="Enabled"
                              unCheckedChildren="Disabled"
                              checked={ilt}
                              onChange={(checked) => {
                                setIlt(checked);
                              }}
                              style={{
                                backgroundColor: ilt ? "#87d068" : "#1890ff",
                              }}
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </div>
              </>
            ) : (
              <></>
            )}
            {record.application === "TraineryLMS" && (
              <>
                <div className="antd-test-modal">
                  <Row gutter={20} style={{ marginLeft: "3rem" }}>
                    <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Allocated Courses</p>
                        }
                      >
                        <Form.Item
                          name="allocated_course_count"
                          initialValue={record?.allocated_course_count}
                        >
                          <InputNumber
                            placeholder="Enter no."
                            name="allocated_course_count"
                            className="my-form-input-antd-test"
                            // Add other InputNumber props as needed
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    {/* Total Views Field - Commented out */}
                    {/* <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                      <Form.Item
                        label={<p className="my-form-lables">Total Views</p>}
                      >
                        <Form.Item
                          name="purchased_view_count"
                          rules={[
                            ({ getFieldValue }) => ({
                              required:
                                getFieldValue("subscription_type") ===
                                "By Views",
                              message: "required",
                            }),
                          ]}
                          disabled
                          initialValue={record?.purchased_view_count}
                        >
                          <InputNumber
                            placeholder="Enter no."
                            name="purchased_view_count"
                            disabled
                            className="my-form-input-antd-test"
                            // Add other InputNumber props as needed
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col> */}
                    {/* Add Views Field - Commented out */}
                    {/* <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                      <Form.Item
                        label={<p className="my-form-lables">Add Views</p>}
                      >
                        <Button
                          type="link"
                          onClick={() => {
                            history(
                              `/admin-manager/clients/sub/${record?.organization}/lms/${record?.id}`
                            );
                          }}
                          style={{ padding: 0 }}
                        >
                          Go to Add Views
                        </Button>
                      </Form.Item>
                    </Col> */}
                    {/* Allocated Views Field - Commented out */}
                    {/* <Col
                      xs={24}
                      sm={12}
                      md={3}
                      lg={4}
                      xl={4}
                      style={{ display: "flex" }}
                    >
                      <Form.Item
                        label={
                          <p className="my-form-lables">Allocated Views</p>
                        }
                      >
                        <Form.Item
                          name="allocated_view_flag"
                          initialValue={record?.allocated_view_flag}
                        >
                          <Switch
                            checkedChildren="Unlimited"
                            unCheckedChildren="Fixed"
                            checked={allocated_views_switch}
                            onChange={(checked) =>
                              setAllocated_views_switch(checked)
                            }
                            style={{
                              backgroundColor: allocated_views_switch
                                ? "#87d068"
                                : "#1890ff",
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                      {!allocated_views_switch && false && (
                        <div
                          style={{
                            display: "inline-block",
                            marginLeft: "0.2rem",
                          }}
                        >
                          <Form.Item label={<p className="my-form-lables"></p>}>
                            <Form.Item
                              name="allocated_view_count"
                              rules={[
                                {
                                  required: true,
                                  message: "required",
                                },
                              ]}
                              initialValue={record?.allocated_view_count}
                            >
                              <InputNumber
                                placeholder="Views"
                                name="allocated_view_count"
                                className="my-form-input"
                                style={{ width: "8rem" }}
                                // Add other InputNumber props as needed
                              />
                            </Form.Item>
                          </Form.Item>
                        </div>
                      )}
                    </Col> */}
                    {/* ILT Field - Kept visible */}
                    {env !== "prod" ? (
                      <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                        <Form.Item>
                          <Form.Item
                            style={{ marginLeft: "30px" }}
                            label={<p className="my-form-lables">ILT</p>}
                            initialValue={record?.ilt_enabled}
                          >
                            <Form.Item name="ilt_enabled">
                              <Switch
                                checkedChildren="Enabled"
                                unCheckedChildren="Disabled"
                                checked={ilt}
                                onChange={(checked) => {
                                  setIlt(checked);
                                }}
                                style={{
                                  backgroundColor: ilt ? "#87d068" : "#1890ff",
                                }}
                              />
                            </Form.Item>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </div>
              </>
            )}
            {/* {record.application === "CompBldr" && (
              <>
                <div className="antd-test-modal">
                  <Form.List name="products">
                    {(fields, { add, remove }) => (
                      <>
                        <Row gutter={20} style={{ marginLeft: "3rem" }}>
                          {fields.map((field, index) => (
                            <>
                              <Col
                                key={field.key}
                                xs={24}
                                sm={12}
                                md={3}
                                lg={4}
                                xl={4}
                              >
                                <Form.Item
                                  label={
                                    <p className="my-form-lables">Product</p>
                                  }
                                  {...field}
                                  name={[field.name, "id"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a product",
                                    },
                                    {
                                      validator: (_, value) =>
                                        isProductUnique(value),
                                      validateTrigger: "onChange",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder="Select a Product"
                                    className="my-form-input-antd-test"
                                  >
                                    {compBldrProducts.map((product) => (
                                      <Option
                                        key={product.id}
                                        value={product.id}
                                      >
                                        {product?.description}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={12} md={3} lg={4} xl={4}>
                                <Form.Item
                                  label={
                                    <p className="my-form-lables">
                                      Billing Cycle
                                    </p>
                                  }
                                  {...field}
                                  name={[field.name, "billing_cycle"]}
                                >
                                  <Select
                                    placeholder="Billing"
                                    name="billing_cycle"
                                    className="my-form-input-antd-test"
                                    // onChange={handleBillingCycleChange}
                                  >
                                    {billings?.billing_cycle?.map((app) => (
                                      <Option key={app} value={app}>
                                        {app}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                                <Form.Item
                                  label={
                                    <p className="my-form-lables">
                                      Start and End Date
                                    </p>
                                  }
                                  {...field}
                                  name={[field.name, "dateRange"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "date is required",
                                    },
                                  ]}
                                >
                                  <RangePicker
                                    placeholder={["Start Date", "End Date"]}
                                    name="dateRange"
                                    className="my-form-input-antd-test"
                                    format="MMM-DD-YYYY"
                                  />
                                </Form.Item>
                              </Col>
                              {compBldrProducts.length > fields.length &&
                                index === fields.length - 1 && (
                                  <Col xs={2} sm={2} md={2} lg={1} xl={1}>
                                    <Form.Item
                                      label={<p className="my-form-lables"></p>}
                                    >
                                      <Form.Item>
                                        <Button
                                          onClick={() => addRow()}
                                          icon={
                                            <PlusOutlined
                                              style={{ color: "#52c41a" }}
                                            />
                                          }
                                        />
                                      </Form.Item>
                                    </Form.Item>
                                  </Col>
                                )}
                              {fields.length > 1 && (
                                <Col xs={2} sm={2} md={2} lg={1} xl={1}>
                                  <Form.Item
                                    label={<p className="my-form-lables"></p>}
                                  >
                                    <Form.Item>
                                      <Button
                                        onClick={() => removeRow(index)}
                                        icon={
                                          <DeleteTwoTone twoToneColor="#eb2f96" />
                                        }
                                      />
                                    </Form.Item>
                                  </Form.Item>
                                </Col>
                              )}
                              <Col xs={2} sm={2} md={4} lg={5} xl={5}></Col>
                            </>
                          ))}
                        </Row>
                      </>
                    )}
                  </Form.List>
                </div>
              </>
            )} */}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              height: "2rem",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <Form.Item style={{ marginRight: "1rem" }}>
              <Button key="back" onClick={() => handleReset(record.id)}>
                <CloseOutlined />
                Cancel
              </Button>
            </Form.Item>
            {(record?.application === "GRADEBldr" ||
              record?.application === "JA/MP") && (
              <Form.Item style={{ marginRight: "1rem" }}>
                <Button
                  key="back"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                    color: "white",
                  }}
                  onClick={() => handleUpgrade(record.id)}
                >
                  {record.application === "GRADEBldr" ? (
                    <>
                      <CaretUpOutlined />
                      Upgrade to JA/MP
                    </>
                  ) : (
                    <>
                      <CaretDownOutlined />
                      Downgrade to GRADEBldr
                    </>
                  )}
                </Button>
              </Form.Item>
            )}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#f58029",
                  fontWeight: "600",
                }}
                className="save-update-btn"
              >
                Update
                <FormOutlined />
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
      <UpdateSub
        visible={showModal}
        handleCancel={() => setShowModal(false)}
        billings={billings}
        application={record.application}
        renderApplication={renderApplication}
        start_date={record.start_date}
        end_date={record.end_date}
        billing_cycle={record?.billing_cycle}
        contract_id={record?.contract_id}
        app_id={record.id}
        upgradeSuccessfull={CreateSuccessfull}
        upgradeFailed={CreateFailed}
      />
    </div>
  );
};

export default EditSubRow;
